import Navbar from "./Navbar"

const Error = () => {
    return(
        <>
        <Navbar></Navbar>
        404 not found
        </>
    )
}

export default Error